import { defineMessages } from 'react-intl.macro';

export default defineMessages({
    empty: {
        id: 'attendance.table.empty',
        defaultMessage: 'No students to display',
    },
    header: {
        id: 'attendance.table.header',
        defaultMessage: 'Roster ({rosterSize})',
    },
    refresh: {
        id: 'attendance.table.refresh',
        defaultMessage: 'Refresh',
    },
    markAttendance: {
        id: 'attendance.header.markAttendance',
        defaultMessage: 'Mark attendance',
    },
    itemsDisplayedAriaLabel: {
        id: 'attendance.header.displayedAriaLabel',
        defaultMessage: 'Displaying items {firstIndex} to {lastIndex} of {totalItemsCount}',
    },
    loading: {
        id: 'attendance.table.loading',
        defaultMessage: 'Loading attendance...',
    },
    nameColumn: {
        id: 'attendance.table.column.name',
        defaultMessage: 'Name',
    },
    emailColumn: {
        id: 'attendance.table.column.email',
        defaultMessage: 'Email',
    },
    customerColumn: {
        id: 'attendance.table.column.customer',
        defaultMessage: 'Customer',
    },
    subscriptionColumn: {
        id: 'attendance.table.column.subscription',
        defaultMessage: 'Subscription',
    },
    hasSubscription: {
        id: 'attendance.table.hasSubscription',
        defaultMessage: 'Yes',
    },
    doesNotHaveSubscription: {
        id: 'attendance.table.doesNotHaveSubscription',
        defaultMessage: 'No',
    },
    enrollmentColumn: {
        id: 'attendance.table.column.enrollment',
        defaultMessage: 'Enrollment',
    },
    attendanceColumn: {
        id: 'attendance.table.column.attendance',
        defaultMessage: 'Attendance',
    },
    attendedStatus: {
        id: 'attendance.table.attendedStatus',
        defaultMessage: 'Attended',
    },
    noShowStatus: {
        id: 'attendance.table.noShowStatus',
        defaultMessage: 'No show',
    },
    partiallyAttendedStatus: {
        id: 'attendance.table.partiallyAttendedStatus',
        defaultMessage: 'Partially attended',
    },
    unknown: {
        id: 'attendance.table.unknownStatus',
        defaultMessage: '--',
    },
    evaluationColumn: {
        id: 'attendance.table.column.evaluation',
        defaultMessage: 'Evaluation',
    },
    attendanceLoadErrorContent: {
        id: 'attendance.table.load.content',
        defaultMessage: 'We are having trouble loading the roster, try refreshing the table.',
    },
    evaluationCompletedStatus: {
        id: 'attendance.table.evaluationCompletedStatus',
        defaultMessage: 'Complete',
    },
    evaluationIncompleteStatus: {
        id: 'attendance.table.evaluationIncompleteStatus',
        defaultMessage: 'Incomplete',
    },
    pageSizeLabel: {
        id: 'attendance.table.pageSize',
        defaultMessage: 'Items per page',
    },
    itemsLabel: {
        id: 'attendance.table.items',
        defaultMessage: 'Items',
    },
    preferencesTitle: {
        id: 'attendance.table.preferences',
        defaultMessage: 'Preferences',
    },
    confirmLabel: {
        id: 'attendance.table.confirm',
        defaultMessage: 'Confirm',
    },
    cancelLabel: {
        id: 'attendance.table.cancel',
        defaultMessage: 'Cancel',
    },
    filterNoMatch: {
        id: 'attendance.filter.noMatch',
        defaultMessage: 'No students match your search',
    },
    filterClear: {
        id: 'attendance.filter.clear',
        defaultMessage: 'Clear filter',
    },
});
